import { CheckNotes, InspectionCase } from '../inspection-cases';

export class InstallationRequirementsDto extends InspectionCase {
  item_8_1?: InspectionCase;
  item_8_2?: InspectionCase;
  item_8_3?: InspectionCase;
  item_8_4?: InspectionCase;
  item_8_5?: InspectionCase;
  item_8_6?: InspectionCase;
  item_8_7?: InspectionCase;
  item_8_8?: InspectionCase;
  item_8_9?: InspectionCase;
  item_8_10?: InspectionCase;
  item_8_11?: InspectionCase;
  item_8_12?: InspectionCase;
  item_8_13?: InspectionCase;
  item_8_14?: InspectionCase;
  item_8_15?: InspectionCase;
  item_8_16?: InspectionCase;
  item_8_17?: InspectionCase;
  item_8_18?: InspectionCase;
}

export class InstallationRequirements extends InstallationRequirementsDto {
  constructor(
    data: InstallationRequirementsDto = {
      title: 'דרישות ההתקנה'
    }
  ) {
    super(data);
    this.item_8_1 = new InspectionCase({
      ...data.item_8_1,
      title: `משקל האירוסול מתאים לנפח החלל`
    });
    this.item_8_2 = new InspectionCase({
      ...data.item_8_2,
      title: `טמפ' הסביבה תואמת את הטמפ' המותרת ע"י היצרן`
    });
    this.item_8_3 = new InspectionCase({
      ...data.item_8_3,
      title: `המרחק בין המחולל לכבלי החשמל או חומר בעיר בהתאם להוראות היצרן`
    });
    this.item_8_4 = new InspectionCase({
      ...data.item_8_4,
      title: `תנוחת המחולל ,התקנתו וחיזוקו בהתאם להוראות היצרן`
    });
    this.item_8_5 = new InspectionCase({
      ...data.item_8_5,
      title: `אין גורם המפריע לפעולתו התקינה של המחולל`
    });
    this.item_8_6 = new InspectionCase({
      ...data.item_8_6,
      title: `המחולל מותקן באופן שניתן לתחזקו`
    });
    this.item_8_7 = new InspectionCase({
      ...data.item_8_7,
      title: `בוצע איטום לארון החשמל`
    });
    this.item_8_8 = new InspectionCase({
      ...data.item_8_8,
      title: `חיבור הנפץ על גבי המיכל הינו בר קיימא`
    });
    this.item_8_9 = new InspectionCase({
      ...data.item_8_9,
      title: `נבדקה פעולת גלאי העשן `
    });
    this.item_8_10 = new InspectionCase({
      ...data.item_8_10,
      title: `הקו בין הרכזת לנפץ מבוקר כנגד נתק בקו`
    });
    this.item_8_11 = new InspectionCase({
      ...data.item_8_11,
      title: `הפעלת הגלאי בארון החשמל מפעיל את הנפץ`
    });
    this.item_8_12 = new InspectionCase({
      ...data.item_8_12,
      title: `נבדקה הפעלת הלחצן`
    });
    this.item_8_13 = new InspectionCase({
      ...data.item_8_13,
      title: 'בדיקת ניתוק חשמל'
    });
    this.item_8_14 = new InspectionCase({
      ...data.item_8_14,
      title: `החייגן מחייג לכיבוי אש או לבעל הנכס (מחק את המיותר)`
    });
    this.item_8_15 = new InspectionCase({
      ...data.item_8_15,
      title: `הצופר נשמע היטב`
    });
    this.item_8_16 = new InspectionCase({
      ...data.item_8_16,
      title: `התקבל מסמך "הודעת סיום" ממתקין המערכת`
    });
    this.item_8_17 = new InspectionCase({
      ...data.item_8_17,
      title: `ההתקנה בוצעה ע"י מתקין שהוסמך בכתב ע"י יצרן הציוד או נציגו `
    });
    this.item_8_18 = new InspectionCase({
      ...data.item_8_18,
      title: `בסיום הבדיקה המזמין החזיר לפעולה את מערכת הכיבוי (הנפצים מחוברים לרכזת)`
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.item_8_1.isApplicable || this.item_8_1.isPassed) &&
        (!this.item_8_2.isApplicable || this.item_8_2.isPassed) &&
        (!this.item_8_3.isApplicable || this.item_8_3.isPassed) &&
        (!this.item_8_4.isApplicable || this.item_8_4.isPassed) &&
        (!this.item_8_5.isApplicable || this.item_8_5.isPassed) &&
        (!this.item_8_6.isApplicable || this.item_8_6.isPassed) &&
        (!this.item_8_7.isApplicable || this.item_8_7.isPassed) &&
        (!this.item_8_8.isApplicable || this.item_8_8.isPassed) &&
        (!this.item_8_9.isApplicable || this.item_8_9.isPassed) &&
        (!this.item_8_10.isApplicable || this.item_8_10.isPassed) &&
        (!this.item_8_11.isApplicable || this.item_8_11.isPassed) &&
        (!this.item_8_12.isApplicable || this.item_8_12.isPassed) &&
        (!this.item_8_13.isApplicable || this.item_8_13.isPassed) &&
        (!this.item_8_14.isApplicable || this.item_8_14.isPassed) &&
        (!this.item_8_15.isApplicable || this.item_8_15.isPassed) &&
        (!this.item_8_16.isApplicable || this.item_8_16.isPassed) &&
        (!this.item_8_17.isApplicable || this.item_8_17.isPassed) &&
        (!this.item_8_18.isApplicable || this.item_8_18.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.item_8_1.getNotes(),
      ...this.item_8_2.getNotes(),
      ...this.item_8_3.getNotes(),
      ...this.item_8_4.getNotes(),
      ...this.item_8_5.getNotes(),
      ...this.item_8_6.getNotes(),
      ...this.item_8_7.getNotes(),
      ...this.item_8_8.getNotes(),
      ...this.item_8_9.getNotes(),
      ...this.item_8_10.getNotes(),
      ...this.item_8_11.getNotes(),
      ...this.item_8_12.getNotes(),
      ...this.item_8_13.getNotes(),
      ...this.item_8_14.getNotes(),
      ...this.item_8_15.getNotes(),
      ...this.item_8_16.getNotes(),
      ...this.item_8_17.getNotes(),
      ...this.item_8_18.getNotes()
    ];
  }
}
